<script setup>
import { CsTransitionChild } from '../transition';
import { useModalContext } from './useModal';

const { onBackdropClick } = useModalContext();
</script>

<template>
  <CsTransitionChild
    enter-active-class="transition ease-out duration-300"
    enter-class="opacity-0"
    enter-to-class="opacity-100"
    leave-active-class="transition ease-in duration-200"
    leave-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div
      data-slot="backdrop"
      class="fixed inset-0 bg-[rgba(0,0,0,.5)] transition-opacity z-[var(--modal-z-index)]"
      aria-hidden="true"
      @click="onBackdropClick"
    />
  </CsTransitionChild>
</template>
